import { render, staticRenderFns } from "./ResultShareBoss.vue?vue&type=template&id=40eb9802&scoped=true"
import script from "./ResultShareBoss.vue?vue&type=script&lang=js"
export * from "./ResultShareBoss.vue?vue&type=script&lang=js"
import style0 from "./ResultShareBoss.vue?vue&type=style&index=0&id=40eb9802&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eb9802",
  null
  
)

export default component.exports